export const NODE_THEME = {
  exception_type: {
    color: '#22D3EE',
    borderColor: '#0891B2',
    size: { width: 120, height: 50 },
  },
  resolution_pattern: {
    color: '#4ADE80',
    borderColor: '#16A34A',
    size: { width: 140, height: 50 },
  },
  xbrl_concept: {
    color: '#60A5FA',
    altColor: '#FB923C',
    borderColor: '#2563EB',
    size: { width: 130, height: 50 },
  },
  reference_document: {
    color: '#94A3B8',
    borderColor: '#64748B',
    size: { width: 140, height: 50 },
  },
  control_objective: {
    color: '#A78BFA',
    borderColor: '#7C3AED',
    size: { width: 130, height: 50 },
  },
  failure_pattern: {
    color: '#F87171',
    borderColor: '#DC2626',
    size: { width: 120, height: 50 },
  },
  detection_rule: {
    color: '#FACC15',
    borderColor: '#CA8A04',
    size: { width: 80, height: 35 },
  },
} as const

export const EDGE_THEME: Record<string, { color: string; dash?: string }> = {
  resolved_by:       { color: '#4ADE80' },
  debit_account:     { color: '#60A5FA' },
  credit_account:    { color: '#FB923C' },
  cites_standard:    { color: '#94A3B8', dash: '6 3' },
  governed_by:       { color: '#94A3B8', dash: '2 2' },
  detects:           { color: '#FACC15' },
  maps_to:           { color: '#E879F9', dash: '6 3' },
  rolls_up_to:       { color: '#60A5FA', dash: '2 2' },
  indicates_failure: { color: '#F87171' },
  violates:          { color: '#F87171', dash: '6 3' },
}
